import { createClass as _createClass, toConsumableArray as _toConsumableArray, classCallCheck as _classCallCheck } from './_virtual/_rollupPluginBabelHelpers.esm.js';

// import { getScrollbarSize, ownerDocument, ownerWindow } from '@costar-ui/utils'

// Is a vertical scrollbar displayed?
// function isOverflowing(container: Element) {
//   const doc = ownerDocument(container)

//   if (doc.body === container) {
//     return ownerWindow(doc).innerWidth > doc.documentElement.clientWidth
//   }

//   return container.scrollHeight > container.clientHeight
// }

function ariaHidden(node, show) {
  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}
function setOverlayData(node, show) {
  if (node) {
    if (show) {
      node.setAttribute('data-hidden', 'true');
    } else {
      node.removeAttribute('data-hidden');
    }
  }
}

// function getPaddingRight(node: Element) {
//   return (
//     parseInt((window.getComputedStyle(node) as never)['padding-right'], 10) || 0
//   )
// }

function ariaHiddenSiblings(container, mountNode, currentNode) {
  var nodesToExclude = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var show = arguments.length > 4 ? arguments[4] : undefined;
  var blacklist = [mountNode, currentNode, currentNode === null || currentNode === void 0 ? void 0 : currentNode.parentElement].concat(_toConsumableArray(nodesToExclude));
  var blacklistTagNames = ['TEMPLATE', 'SCRIPT', 'STYLE'];
  [].forEach.call(container.children, function (node) {
    if (node && node.nodeType === 1 && blacklist.indexOf(node) === -1 && blacklistTagNames.indexOf(node.tagName) === -1) {
      ariaHidden(node, show);
    }
  });
}
function findIndexOf(containerInfo, callback) {
  var idx = -1;
  containerInfo.some(function (item, index) {
    if (callback(item)) {
      idx = index;
      return true;
    }
    return false;
  });
  return idx;
}

// means to provide a way to restore state to the hosting container
// with aria modal component this is already being handle.
// code is commented out for now to provide a stub code as an idea
// when we come across future use case that may need something like this.
// function handleContainer(
//   containerInfo: ModalContainer,
//   props: { disableScrollLock?: boolean; scrollBarWidth?: number }
// ) {
//   const restoreStyle: {
//     value: string | null
//     key: string
//     el: HTMLDivElement
//   }[] = []
//   const restorePaddings: string[] = []
//   const container = containerInfo.container
//   let fixedNodes: NodeListOf<Element>

//   if (!props.disableScrollLock && container) {
//     if (isOverflowing(container)) {
//       const _container = container as HTMLDivElement
//       // Compute the size before applying overflow hidden to avoid any scroll jumps.
//       const scrollbarSize = props.scrollBarWidth
//         ? props.scrollBarWidth
//         : getScrollbarSize()

//       restoreStyle.push({
//         value: _container.style.paddingRight,
//         key: 'padding-right',
//         el: _container
//       })

//       // Use computed style, here to get the real padding to add our scrollbar width.
//       _container.style.paddingRight = `${
//         getPaddingRight(container) + scrollbarSize
//       }px`

//       // .csg-tui-fixed is a global helper.
//       fixedNodes = ownerDocument(container).querySelectorAll('.csg-tui-fixed')
//       ;[].forEach.call(fixedNodes, (node: HTMLDivElement) => {
//         restorePaddings.push(node.style.paddingRight)
//         node.style.paddingRight = `${getPaddingRight(node) + scrollbarSize}px`
//       })
//     }

//     // Improve Gatsby support
//     // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
//     const parent = container.parentElement
//     const scrollContainer =
//       parent &&
//       parent.nodeName === 'HTML' &&
//       (window.getComputedStyle(parent) as never)['overflow-y'] === 'scroll'
//         ? parent
//         : container

//     // Block the scroll even if no scrollbar is visible to account for mobile keyboard
//     // screen size shrink.
//     restoreStyle.push({
//       value: (scrollContainer as HTMLDivElement).style.overflow,
//       key: 'overflow',
//       el: scrollContainer as HTMLDivElement
//     })
//     ;(scrollContainer as HTMLDivElement).style.overflow = 'hidden'
//   }

//   const restore = () => {
//     if (fixedNodes) {
//       ;[].forEach.call(fixedNodes, (node: HTMLDivElement, i) => {
//         if (restorePaddings[i]) {
//           node.style.paddingRight = restorePaddings[i]
//         } else {
//           node.style.removeProperty('padding-right')
//         }
//       })
//     }

//     restoreStyle.forEach(({ value, el, key }) => {
//       if (value) {
//         el.style.setProperty(key, value)
//       } else {
//         el.style.removeProperty(key)
//       }
//     })
//   }

//   return restore
// }

function getHiddenSiblings(container) {
  var hiddenSiblings = [];
  [].forEach.call(container.children, function (node) {
    if (node.getAttribute && node.getAttribute('aria-hidden') === 'true') {
      hiddenSiblings.push(node);
    }
  });
  return hiddenSiblings;
}

/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */
var PrivateModalManager = /*#__PURE__*/function () {
  function PrivateModalManager() {
    _classCallCheck(this, PrivateModalManager);
    this.modals = [];
    this.containers = [];
  }
  _createClass(PrivateModalManager, [{
    key: "add",
    value: function add(modal, container) {
      // eslint-disable-next-line no-console
      // console.log('------ modal-manager add ------')

      var modalIndex = this.modals.indexOf(modal);
      if (modalIndex !== -1) {
        return modalIndex;
      }
      modalIndex = this.modals.length;
      this.modals.push(modal);

      // If the modal we are adding is already in the DOM.
      if (modal.modalRef) {
        ariaHidden(modal.modalRef, false);
      }
      if (this.modals.length > 1) {
        var prevModal = this.modals[this.modals.length - 2];
        if (prevModal.modalRef) {
          setOverlayData(prevModal.modalRef.parentNode, true);
        }
      }
      var hiddenSiblingNodes = getHiddenSiblings(container);
      ariaHiddenSiblings(container, modal.mountNode, modal.modalRef, hiddenSiblingNodes, true);
      var containerIndex = findIndexOf(this.containers, function (item) {
        return item.container === container;
      });
      if (containerIndex !== -1) {
        var cur = this.containers[containerIndex];
        if (cur && cur.modals) {
          cur.modals.push(modal);
        }
        return modalIndex;
      }
      this.containers.push({
        modals: [modal],
        container: container,
        restore: undefined,
        hiddenSiblingNodes: hiddenSiblingNodes
      });
      return modalIndex;
    }
  }, {
    key: "mount",
    value: function mount(modal) {
      // eslint-disable-next-line no-console
      // console.log('------ modal-manager mount ------')
      var containerIndex = findIndexOf(this.containers, function (item) {
        return !!item.modals && item.modals.indexOf(modal) !== -1;
      });
      var containerInfo = this.containers[containerIndex];
      if (!containerInfo.restore) ;
    }
  }, {
    key: "remove",
    value: function remove(modal) {
      // eslint-disable-next-line no-console
      // console.log('------ modal-manager remove ------')
      var modalIndex = this.modals.indexOf(modal);
      if (modalIndex === -1) {
        return modalIndex;
      }
      var containerIndex = findIndexOf(this.containers, function (item) {
        return !!item.modals && item.modals.indexOf(modal) !== -1;
      });
      var containerInfo = this.containers[containerIndex];
      if (containerInfo && containerInfo.modals) {
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);

        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0 && containerInfo.container) {
          // The modal might be closed before it had the chance to be mounted in the DOM.
          if (containerInfo.restore) {
            containerInfo.restore();
          }
          if (modal.modalRef) {
            // In case the modal wasn't in the DOM yet.
            ariaHidden(modal.modalRef, true);
          }
          ariaHiddenSiblings(containerInfo.container, modal.mountNode, modal.modalRef, containerInfo.hiddenSiblingNodes, false);
          this.containers.splice(containerIndex, 1);
        } else {
          // Otherwise make sure the next top modal is visible to a screen reader.
          var nextTop = containerInfo.modals[containerInfo.modals.length - 1];
          // as soon as a modal is adding its modalRef is undefined. it can't set
          // aria-hidden because the dom element doesn't exist either
          // when modal was unmounted before modalRef gets null
          if (nextTop.modalRef) {
            ariaHidden(nextTop.modalRef, false);
            setOverlayData(nextTop.modalRef.parentNode, false);
          }
        }
      }
      return modalIndex;
    }
  }, {
    key: "isTopModal",
    value: function isTopModal(modal) {
      return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
  }]);
  return PrivateModalManager;
}();
var ModalManager = PrivateModalManager;

export { ModalManager as default };
//# sourceMappingURL=modal-manager.esm.js.map
